import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import {titleCase} from '../../../../utils/views/pages/Dynamics'
import ImageViewer from "./ImageViewer";

const StudentInformation = (props) => {
    const student = props.student
    const formDisabled = props.formDisabled
    const setStudent = props.setStudent
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {                
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {
        
        student[e.target.name] = e.target.value
        setStudent(student)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Student information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <ImageViewer
                            student={student}
                            setStudent={setStudent}
                            formDisabled={formDisabled}
                        ></ImageViewer>
                    </Col>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-name"
                            >
                                Full Name
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={student?.name}
                                id="input-name"
                                name="name"
                                placeholder="Student Full Name"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>       
                    
                    
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default StudentInformation;